import React from "react";
import {Outlet} from "react-router-dom";
import s from "./authLayout.module.scss";
import blurredAuthBgBL from "../../assets/img/blurredAuthBgBL.png";
import blurredAuthBgTR from "../../assets/img/blurredAuthBgTR.png";
import iphonesImg from "../../assets/img/iphonesAuthBgImg.png";
import {languageOptions} from "../../components/LanguageDropdown/LanguageDropdown";
import {getLanguage, setLanguage} from "../../storage/switchLanguage";
import {useTranslation} from "react-i18next";

const AuthLayout = () => {

    const {i18n} = useTranslation();

    return (
        <div className={s.authWrapper}>
            <img src={blurredAuthBgTR} className={s.bgImgBL}/>
            <img src={blurredAuthBgBL} className={s.bgImgTR}/>
            <ul className={s.switchLanguageContainer}>
                {
                    languageOptions.map((lang) => (
                        <li key={lang}>
                            <button
                                className={`${lang === getLanguage() ? s.active : ''}`}
                                onClick={() => {
                                    setLanguage(lang);
                                    i18n.changeLanguage(lang);
                                }}
                            >
                                {lang.toUpperCase()}
                            </button>
                        </li>
                    ))
                }
            </ul>
            <div className={s.authContentWrapper}>
                <div className={s.contentContainer}>
                    <img src={iphonesImg} className={s.iphonesImg} draggable="false"/>
                    <Outlet/>
                </div>
                <div className={s.companyRightsWrapper}>
                    WWA © 2024. All rights reserved.
                </div>
            </div>
        </div>
    );
};

export default AuthLayout;
